import React from 'react'

import photo from '../../images/c24cd35d64b39ae4ba697531c34b374c.png'

import './About.css'
const About = () => {
  return (
    <main className='about'>
      <div className="container">
        <h2 className="about__title">Інтернет-магазин сертифікованих ножів</h2>
        <p className='about__text'>Ласкаво просимо до офіційного сайту «ГОСТРО»! У нашому магазині представлений найбільш широкий вибір Златоустівських ножів від Златоустівських Збройових Фабрик та компаній, ми є офіційними постачальниками. У нашому магазині Ви можете подивитися, порівняти, оцінити та купити сподобався  ніж з офіційною гарантією, не виходячи з дому, маючи під рукою тільки пристрій з виходом в інтернет (ПК, ноутбук, планшет, смартфон) та телефон.</p>
        <p className='about__text'>Оформити замовлення можна без зайвих зусиль, Вам необхідно лише вибрати ніж, натиснути кнопку «Купити» перейти в кошик та заповнити запропоновані поля, і Ваше замовлення вже прийняте! Наші менеджери оперативно зв'яжуться з Вами по телефону та обговорять деталі замовлення. Ми здійснюємо доставку продукції в будь-який населений пункт по всій Україні</p>
        <div className="about__img">
          <img src={photo} alt="" />
        </div>
      </div>
    </main>
  )
}

export default About